import { render } from "./NewsList.vue?vue&type=template&id=7346b104&scoped=true"
import script from "./NewsList.vue?vue&type=script&lang=js"
export * from "./NewsList.vue?vue&type=script&lang=js"

import "./NewsList.vue?vue&type=style&index=0&id=7346b104&lang=scss&scoped=true"

import exportComponent from "D:\\digitalnewspaper\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7346b104"]])

export default __exports__